<template>
	<v-expansion-panels v-model="open" flat class="promo-step__panels">
		<v-expansion-panel value="campaign" rounded="lg" :class="[status ? `promo-step__status promo-step__status--${status}` : '']">
			<v-expansion-panel-title hide-actions :hover="false">
				<template #default="{ expanded }">
					<div class="d-flex align-center ga-3 w-100">
						<v-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</v-icon>
						<v-icon v-if="campaign.promoLocal" size="small">flag</v-icon>
						<div class="flex-grow-1">
							<div class="text-title-medium font-weight-bold">{{ campaign.label }}</div>
							<div v-if="subtitle" class="text-body-small text-medium-emphasis">{{ subtitle }}</div>
						</div>
						<v-chip v-if="periodChip" color="primary" size="small">{{ periodChip }}</v-chip>
					</div>
				</template>
			</v-expansion-panel-title>
			<v-expansion-panel-text>
				<v-divider class="mb-4" />
				<PromoCampaignBody :campaign="campaign" />
			</v-expansion-panel-text>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script setup>
import { ref, toRef } from 'vue';
import { usePromoCampaign } from '@/composables/usePromoCampaign';
import PromoCampaignBody from './PromoCampaignBody.vue';

const props = defineProps({
	campaign: { type: Object, required: true },
});

const open = ref(null);
const { status, subtitle, periodChip } = usePromoCampaign(toRef(props, 'campaign'));
</script>
